import React from 'react'
import { isEmpty } from 'AccountsUtils'

import Timer from './Timer'

const TimerBody = ({ isRunning,
  linkExpirationTime,
  isTimerStart,
  expiryTime }) => {
  const initialTimeDiff = +new Date() + expiryTime * 60 * 60 * 1000 + 1000

  return (
    <div className="flex flex-column">

      <Timer
        active={isRunning}
        linkExpirationTime={!isEmpty(linkExpirationTime) ? linkExpirationTime : initialTimeDiff}
        expiryTime={expiryTime}
      />
    </div>
  )
}

export default TimerBody
